/**
 * Batch Processes Detail Store
 */

import { createStore } from '@commandDrivenStateEngine/core/createStore';
import { Policy } from '@commandDrivenStateEngine/core/policies';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { initialState, BatchProcessesDetailState } from './state';
import { handlers } from './handlers';
import { invariants } from './invariants';
import { BatchProcessesDetailCommand } from './commands';
import { createProcessDetailPolicy } from './policies/processDetailPolicy';
import { createReferenceDataPolicy } from './policies/referenceDataPolicy';
import { createBatchProgressPolicy } from './policies/batchProgressPolicy';
import { createRevokedChannelTargetsPolicy } from './policies/revokedChannelTargetsPolicy';

export { selectors } from './state';

const store = createStore({
  name: 'batch-processes-detail',
  initialState,
  handlers,
  invariants
});

export const {
  useSelector: useBatchProcessesDetailSelector,
  useErrors: useBatchProcessesDetailErrors,
  useDispatch: useBatchProcessesDetailDispatch,
  usePolicies: useBatchProcessesDetailPolicies,
  getState: getBatchProcessesDetailState,
  dispatch: dispatchBatchProcessesDetailCommand
} = store;

/**
 * Policy factory - creates policies for the detail batch processes store.
 */
export const createBatchProcessesDetailPolicies = (
  backend: ClientLibraryType,
  processId: string
): Policy<BatchProcessesDetailState, BatchProcessesDetailCommand>[] => [
  createProcessDetailPolicy( backend, processId ),
  createReferenceDataPolicy( backend ),
  createBatchProgressPolicy( backend, processId ),
  createRevokedChannelTargetsPolicy(( integrationId ) => backend.queries.ExternalSystemsIntegrationsById( integrationId ))
];
